import * as React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import KudosContext from "src/context";
import { routes } from "src/routes";
import { ProtectedComponent } from "./ProtectedComponent";
import { LayoutComponent } from "./layout/LayoutComponent";
import { ErrorPageComponent } from "./error-page/ErrorPageComponent";
import { LoginComponent } from "src/components/login/LoginComponent";

export class RoutesComponent extends React.Component<{}> {
  public static contextType = KudosContext;
  public context!: React.ContextType<typeof KudosContext>;

  public render() {
    return (
      <>
        <Route
          exact={true}
          path={routes.main}
          render={() => <Redirect to={routes.auth} />}
        />
        <Switch>
          <ProtectedComponent path={routes.auth} component={LayoutComponent} />
          <Route path={routes.login} component={LoginComponent} />
          <Route component={ErrorPageComponent} />
        </Switch>
      </>
    );
  }
}
